import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 2a2 2 0 0 0-2 2v1.36a4.033 4.033 0 0 1 2.781-.283c2.263.595 3.552 3.077 2.878 5.544-.674 2.467-2.928 4.975-5.562 4.283a3.415 3.415 0 0 1-1.158-.547 3.415 3.415 0 0 1-1.158.547c-2.633.692-4.887-1.816-5.561-4.283-.674-2.467.614-4.949 2.877-5.544.997-.262 2.017-.114 2.903.344V4c0-.182.012-.361.036-.537-.744.432-1.818.41-2.765-.137C3.18 2.696 2.606 1.567 2.812.608 3.54-.052 4.804-.12 5.897.512c.776.448 1.29 1.147 1.449 1.859A4 4 0 0 1 11 0v2Z",
    fill: "currentColor"
  }));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Fruit16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var Fruit16 = createIcon(IconComponent);